import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Configuration from './pages/Configuration';
import BatchManagement from './pages/BatchManagement';
import BatchDetail from './pages/BatchDetail';
import ProductForm from './pages/ProductForm';
import ProductList from './pages/ProductList';
import LearningVideos from './pages/LearningVideos';
import AdminFAQ from './pages/AdminFAQ';
import AdminVideos from './pages/AdminVideos';
import AdminUsers from './pages/AdminUsers';
import AdminUserDetail from './pages/AdminUserDetail';
import AdminCMS from './pages/AdminCMS';
import BulkUpload from './pages/BulkUpload';
import LabelDesigner from './pages/LabelDesigner';
import Rewards from './pages/Rewards';
import FeatureSuggestions from './pages/FeatureSuggestions';
import ShopifyPlanSelect from './pages/ShopifyPlanSelect';
import QuickList from './pages/QuickList';
import AdminResellers from './pages/AdminResellers';
import ShopifyReadiness from './pages/ShopifyReadiness';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ContactUs from './pages/ContactUs';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PrivacyPolicyPublic from './pages/PrivacyPolicyPublic';
import TermsOfService from './pages/TermsOfService';
import IntegrationDetail from './pages/IntegrationDetail';
import AppLayout from './components/AppLayout';
import './index.css';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
      <div className="w-8 h-8 border-4 border-[#0052FF] border-t-transparent rounded-full animate-spin" />
    </div>
  );
  if (!user || user === false) return <Navigate to="/login" />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user && user !== false) return <Navigate to="/dashboard" />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicRoute><Landing /></PublicRoute>} />
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/privacy" element={<PrivacyPolicyPublic />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/integrations/:slug" element={<IntegrationDetail />} />
          <Route path="/dashboard" element={<ProtectedRoute><AppLayout><Dashboard /></AppLayout></ProtectedRoute>} />
          <Route path="/configuration" element={<ProtectedRoute><AppLayout><Configuration /></AppLayout></ProtectedRoute>} />
          <Route path="/batch-management" element={<ProtectedRoute><AppLayout><BatchManagement /></AppLayout></ProtectedRoute>} />
          <Route path="/batches/:batchId" element={<ProtectedRoute><AppLayout><BatchDetail /></AppLayout></ProtectedRoute>} />
          <Route path="/product-form" element={<ProtectedRoute><AppLayout><ProductForm /></AppLayout></ProtectedRoute>} />
          <Route path="/product-list" element={<ProtectedRoute><AppLayout><ProductList /></AppLayout></ProtectedRoute>} />
          <Route path="/bulk-upload" element={<ProtectedRoute><AppLayout><BulkUpload /></AppLayout></ProtectedRoute>} />
          <Route path="/label-designer" element={<ProtectedRoute><AppLayout><LabelDesigner /></AppLayout></ProtectedRoute>} />
          <Route path="/rewards" element={<ProtectedRoute><AppLayout><Rewards /></AppLayout></ProtectedRoute>} />
          <Route path="/feature-suggestions" element={<ProtectedRoute><AppLayout><FeatureSuggestions /></AppLayout></ProtectedRoute>} />
          <Route path="/shopify-plan-select" element={<ProtectedRoute><ShopifyPlanSelect /></ProtectedRoute>} />
          <Route path="/quick-list" element={<ProtectedRoute><QuickList /></ProtectedRoute>} />
          <Route path="/admin-resellers" element={<ProtectedRoute><AppLayout><AdminResellers /></AppLayout></ProtectedRoute>} />
          <Route path="/learning-videos" element={<ProtectedRoute><AppLayout><LearningVideos /></AppLayout></ProtectedRoute>} />
          <Route path="/admin-faq" element={<ProtectedRoute><AppLayout><AdminFAQ /></AppLayout></ProtectedRoute>} />
          <Route path="/admin-videos" element={<ProtectedRoute><AppLayout><AdminVideos /></AppLayout></ProtectedRoute>} />
          <Route path="/admin-users" element={<ProtectedRoute><AppLayout><AdminUsers /></AppLayout></ProtectedRoute>} />
          <Route path="/admin-users/:username" element={<ProtectedRoute><AppLayout><AdminUserDetail /></AppLayout></ProtectedRoute>} />
          <Route path="/admin-cms" element={<ProtectedRoute><AppLayout><AdminCMS /></AppLayout></ProtectedRoute>} />
          <Route path="/shopify-readiness" element={<ProtectedRoute><AppLayout><ShopifyReadiness /></AppLayout></ProtectedRoute>} />
          <Route path="/privacy-policy" element={<ProtectedRoute><AppLayout><PrivacyPolicy /></AppLayout></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
